import { create } from 'zustand';
import {
    MRT_PaginationState,
    MRT_SortingState,
    MRT_RowSelectionState,
    MRT_ColumnFiltersState,
} from 'mantine-react-table';

export type DateRange = [Date | null, Date | null];

export interface RequestsTableState {
    pagination: MRT_PaginationState;
    setPagination: (pagination: MRT_PaginationState) => void;
    isSillyGoose: boolean;
    sorting: MRT_SortingState;
    setSorting: (sorting: MRT_SortingState) => void;
    globalFilter: string;
    setGlobalFilter: (filter: string) => void;
    rowSelection: MRT_RowSelectionState;
    setRowSelection: (selection: MRT_RowSelectionState) => void;
    columnFilters: MRT_ColumnFiltersState;
    setColumnFilters: (filters: MRT_ColumnFiltersState) => void;
    sapOutcomeFilter: string[] | null;
    setSapOutcomeFilter: (filter: string[] | null) => void;
    advertisingZoneFilter: string[] | null;
    setAdvertisingZoneFilter: (filter: string[] | null) => void;
    procurementManagerFilter: string[] | null;
    setProcurementManagerFilter: (filter: string[] | null) => void;
    productCategoryFilter: string[] | null;
    setProductCategoryFilter: (filter: string[] | null) => void;
    operationsAreaFilter: string[] | null;
    setOperationsAreaFilter: (filter: string[] | null) => void;
    divisionFilter: string[] | null;
    setDivisionFilter: (filter: string[] | null) => void;
    storeFilter: string[] | null;
    setStoreFilter: (filter: string[] | null) => void;
    friendlyIdFilter: string[] | null;
    setFriendlyIdFilter: (filter: string[] | null) => void;
    dateRange: DateRange;
    setDateRange: (range: DateRange) => void;
    selectingDates: boolean;
    setSelectingDates: (selecting: boolean) => void;
    resetDateRange: () => void;
    resetFilters: () => void;
}

export const useRequestsTableStore = create<RequestsTableState>(set => ({
    pagination: { pageIndex: 0, pageSize: 20 },
    setPagination: pagination => set({ pagination }),
    isSillyGoose: false,
    setIsSillyGoose: (isSillyGoose: boolean) =>
        set({ isSillyGoose: !isSillyGoose }),
    sorting: [],
    setSorting: sorting => set({ sorting }),
    globalFilter: '',
    setGlobalFilter: filter => set({ globalFilter: filter }),
    rowSelection: {},
    setRowSelection: selection => set({ rowSelection: selection }),
    columnFilters: [],
    setColumnFilters: filters => set({ columnFilters: filters }),
    sapOutcomeFilter: null,
    setSapOutcomeFilter: filter => set({ sapOutcomeFilter: filter }),
    advertisingZoneFilter: null,
    setAdvertisingZoneFilter: filter => set({ advertisingZoneFilter: filter }),
    procurementManagerFilter: null,
    setProcurementManagerFilter: filter =>
        set({ procurementManagerFilter: filter }),
    productCategoryFilter: null,
    setProductCategoryFilter: filter => set({ productCategoryFilter: filter }),
    operationsAreaFilter: null,
    setOperationsAreaFilter: filter => set({ operationsAreaFilter: filter }),
    divisionFilter: null,
    setDivisionFilter: filter => set({ divisionFilter: filter }),
    storeFilter: null,
    setStoreFilter: filter => set({ storeFilter: filter }),
    friendlyIdFilter: null,
    setFriendlyIdFilter: filter => set({ friendlyIdFilter: filter }),
    dateRange: [null, null],
    setDateRange: range => set({ dateRange: range }),
    selectingDates: false,
    setSelectingDates: selecting => set({ selectingDates: selecting }),
    resetDateRange: () => set({ dateRange: [null, null] }),
    resetFilters: () =>
        set({
            pagination: { pageIndex: 0, pageSize: 20 },
            sorting: [],
            globalFilter: '',
            rowSelection: {},
            columnFilters: [],
            sapOutcomeFilter: null,
            advertisingZoneFilter: null,
            procurementManagerFilter: null,
            productCategoryFilter: null,
            operationsAreaFilter: null,
            divisionFilter: null,
            storeFilter: null,
            friendlyIdFilter: null,
            dateRange: [null, null],
            selectingDates: false,
        }),
}));
